/**
 * autoReplySettingsApi — los dos interruptores de Auto Reply (admin).
 *
 * SHADOW procesa y analiza; SEND envía de verdad. SEND efectivo = techo del
 * servidor (entorno) Y el interruptor de la plataforma. El backend es la
 * frontera: rechaza encender SEND con el techo cerrado o sin `confirm`.
 */
import { api } from "@/lib/api";

export async function getAutoReplySettings() {
  const { data } = await api.get(`/admin/auto-reply/settings`);
  return data;
}

/** `flag`: "shadow" | "send". Encender SEND exige `confirm: true`. */
export async function setAutoReplyFlag(flag, enabled, { confirm = false } = {}) {
  const { data } = await api.put(`/admin/auto-reply/settings/${flag}`, {
    enabled: !!enabled,
    confirm: !!confirm,
  });
  return data;
}
